/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Create
 */

module.exports = {
  
    GenerateTexture: require('./GenerateTexture'),
    Palettes: require('./palettes')

};



//////////////////
// WEBPACK FOOTER
// ./create/index.js
// module id = 477
// module chunks = 0